<template>
  <div>




           <Tabs>
            <TabPane label="充值记录">
                <curtailTable
                ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :tableData="tableData"
                tableApi="admin/site_balance/getBalanceRecord"
    >

      <!-- <div style="margin-top: 20px;">
      <Page :total="total" :current.sync="currentPage" @on-change="handlePageChange" />
    </div> -->
       <template v-slot:searchFormItem>
   
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" @on-change="timeChange" placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>

     
      </template>
    </curtailTable>
             
            </TabPane>
            <TabPane label="订单记录">

                      <curtailTable
                ref="tables"
               :tableTitle="tableColumns"
               :searchData="searchDatas"
               :tableData="tableDatas"
                tableApi="admin/site_balance/getOrder"
    >

      <!-- <div style="margin-top: 20px;">
      <Page :total="total" :current.sync="currentPage" @on-change="handlePageChange" />
    </div> -->
       <template v-slot:searchFormItem>
   
        <FormItem prop="create_time">
          <DatePicker v-model="searchDatas.create_time" type="datetimerange" @on-change="timeChange" placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>

     
      </template>

         <template v-slot:otherBtn>
        <FormItem>
         <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>

      
    </curtailTable>
             
            </TabPane>

               <TabPane label="关联站点日志">

              <curtailTable
                ref="tables"
               :tableTitle="tableArr"
               :searchData="searchArr"
               :tableData="tableArrs"
                tableApi="admin/site_balance/getStationRelatedLog"
    >

      <!-- <div style="margin-top: 20px;">
      <Page :total="total" :current.sync="currentPage" @on-change="handlePageChange" />
    </div> -->
       <template v-slot:searchFormItem>
   
        <FormItem prop="create_time">
          <DatePicker v-model="searchDatas.create_time" type="datetimerange" @on-change="timeChange" placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>

     
      </template>

  
      
    </curtailTable>

               </TabPane>

                         <TabPane label="核销日志">

              <curtailTable
                ref="tables"
               :tableTitle="tableNew"
               :searchData="searchNew"
               :tableData="tableNewarr"
                tableApi="admin/site_balance/getWriteRecord"
    >

      <!-- <div style="margin-top: 20px;">
      <Page :total="total" :current.sync="currentPage" @on-change="handlePageChange" />
    </div> -->
       <template v-slot:searchFormItem>
   
        <FormItem prop="create_time">
          <DatePicker v-model="searchDatas.create_time" type="datetimerange" @on-change="timeChange" placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>

     
      </template>

  
      
    </curtailTable>

               </TabPane>



        </Tabs>



  </div>
</template>

<script>
  import curtailTable from "@/components/table/curtailTable";
  import XLSX from 'xlsx'
  export default {
    name: "companyStation",
    components:{curtailTable},
    props:{
      station_id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        tableData: [] ,
        searchData:{
          create_time:'',
          company_id:'',
          keyword:'',
          pagesize:500,
          type:1,
          station_id:this.station_id
        },
        searchDatas:{
        platform:'',
        create_time:'',
         station_id:this.station_id
        },
        searchNew:{
            create_time:'',
         station_id:this.station_id
        },
        searchArr:{
        create_time:'',
        station_id:this.station_id
        },
        multiPrice:'',
        do_time:'',
        doingMultiSet:false,
        tableColumn: [
          {title: 'ID',key: 'id',align: "center",width:80},
          // {title: '当次操作金额',key: 'money',align: "center"},
          
              {title: '当次操作金额',key: 'money',minWidth:160,align: "left",render:(h,params)=>{
                  let content  =[];
                 let status=parseInt(params.row.status)
                 if(status===1){
                  content.push( h('span',{style:{color:'red',fontSize:'18px',marginRight:'5px'}},'+'))
                 }else{
                   content.push( h('span',{style:{color:'red',fontSize:'18px',marginRight:'5px'}},'-'))
                 }
          
                content.push( h('span',params.row.money))
            
              return h('div',content)
            }},
          {title: '消费前余额',key: 'front_balance',align: "center"},
          {title: '消费后余额',key: 'after_balance',align: "center"},
          {title: '返利金额',key: 'rebate_amount',align: "center"},
          {title: 'ip',key: 'ip',align: "center"},
          {title: '状态',key: 'status',align: "center"},
          {title: '备注',key: 'remarks',align: "center"},
          {title: '操作人',key: 'user_name',align: "center"},
          {title: '时间',key: 'create_time',align: "center"},
        ],
            tableColumns:[
            {title:'ID',key:'id',align:'center'},
           
              {title: '金额',key: 'money',minWidth:160,align: "left",render:(h,params)=>{
                  let content  =[];
                 let status=parseInt(params.row.status)
                 if(status===1){
                  content.push( h('span',{style:{color:'red',fontSize:'18px',marginRight:'5px'}},'+'))
                 }else{
                   content.push( h('span',{style:{color:'red',fontSize:'18px',marginRight:'5px'}},'-'))
                 }
          
                content.push( h('span',params.row.money))
            
              return h('div',content)
            }},
            {title:'消费前金额',key:'front_balance',align:'center'},
            {title:'消费后金额',key:'after_balance',align:'center'},
            {title:'备注',key:'remarks',align:'center'},
            // {title:'状态',key:'status_name',align:'center'},
            {title:'类型',key:'type_name',align:'center'},
             {title:'订单ID',key:'order_id',align:'center'},
            {title:'时间',key:'create_time',align:'center'},
       
        ],
          tableArr:[
            // {title:'ID',key:'id',align:'center'},
            {title:'IP',key:'ip',align:'center'},
            {title:'操作人',key:'user_name',align:'center'},
            {title:'站点',key:'gas_name',align:'center'},
            {title:'关联站点',key:'related_name',align:'center'},
            {title:'时间',key:'create_time',align:'center'},
   
       
        ],
  tableNew:[
         {title: 'ID',key: 'id',align: "center"},
          {title: '核销金额',key: 'write_balance',align: "center"},
          {title: '相差金额',key: 'diff_balance',align: "center"},
          {title: '时间',key: 'create_time',align: "center"},
          {title: '备注',key: 'remarks',align: "center", render: (h, params) => {
              const row = params.row;
              if (row._editingRemarks) {
                return h('div', [
                  h('Input', {
                    props: { value: row._remarksDraft, maxlength: 200 },
                    style: { width: '220px', marginRight: '6px' },
                    on: { input: val => { this.$set(row, '_remarksDraft', val) } }
                  }),
                  h('Button', { props: { type: 'primary', size: 'small' }, on: { click: () => { this.saveRemarks(row) } } }, '保存'),
                  h('Button', { style: { marginLeft: '6px' }, props: { size: 'small' }, on: { click: () => { this.cancelEditRemarks(row) } } }, '取消')
                ])
              }
              return h('div', [
                h('span', row.remarks || '-'),
                h('Button', { style: { marginLeft: '8px' }, props: { type: 'primary', size: 'small' }, on: { click: () => { this.startEditRemarks(row) } } }, '编辑')
              ])
            }}
        ],
        tableNewarr:[],
        tableArrs:[],
         tableDatas:[],
        tableTitle:'总数量:',
        loading:false,
         detailUserID:0,
      }
    },
    mounted(){
      // this.getTableData()
    },
    methods:{
      // 备注编辑：开始编辑
      startEditRemarks(row){
        this.$set(row, '_editingRemarks', true);
        this.$set(row, '_remarksDraft', row.remarks || '');
      },
      // 取消编辑
      cancelEditRemarks(row){
        this.$set(row, '_editingRemarks', false);
        this.$set(row, '_remarksDraft', undefined);
      },
      // 保存备注（新增或编辑）
      async saveRemarks(row){
        let payload = {
          id: row.id,
          remarks: row._remarksDraft || ''
        }
        try{
          let res = await this.$commonFun.postProxy('admin/site_balance/editRecord', payload);
          this.$commonFun.dealApiResult(res, ()=>{
            this.$Message.success(res.msg || '保存成功');
            // 更新本地展示
            this.$set(row, 'remarks', payload.remarks);
            this.$set(row, '_editingRemarks', false);
            this.$set(row, '_remarksDraft', undefined);
          })
        }catch(e){
          // 可选错误处理
        }
      },
          exportData(){
        this.$commonFun.postProxy('admin/site_balance/export',this.searchDatas).then((res)=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`站点消费记录.xlsx`)
          })
        })
      },
      async getTableData(){
        let res = await this.$commonFun.postProxy('admin/site_balance/getBalanceRecord',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          this.tableData = res.data
        })
        return false;
      },
      async editCompanyStationPrice(info){
        let params = {
          company_id: this.companyId,
          station_id:info.station_id,
          price:info.new_company_price,
          retail_prices:info.new_retail_prices
        }
        let res = await this.$commonFun.postProxy('admin/company/editCompanyStationPrice',params);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.getTableData()
            // this.$refs.table.resetSearchForm()
          })
        })
      },
      multiChangePrice(value){
        // this.$refs.table.tableData.forEach(item=>{
        this.tableData.forEach(item=>{
          if (item.company_price && item.company_price>0){
            item.new_company_price =value ? (parseFloat(item.price2)+parseFloat(value)).toFixed(2) : item.company_price;
            item.new_retail_prices =value ? parseFloat(parseFloat(item.retail_prices) - parseFloat(item.company_price) + parseFloat(item.new_company_price)).toFixed(2) : item.retail_prices;
          }else{
            item.new_company_price = 0;
            item.new_retail_prices = 0;
          }
        })
      },
      async multiSetPrice(){
        this.doingMultiSet = true
        // let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,price:this.multiPrice,do_time:this.do_time});
        // let data = this.$refs.table.tableData.map(item=>{
        let data = this.tableData.map(item=>{
          return {station_id:item.station_id,new_company_price:item.new_company_price,new_retail_prices:item.new_retail_prices}
        })
        let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,prices:data,do_time:this.do_time});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg)
          this.getTableData()
          // this.$refs.table.resetSearchForm()
        })
        this.doingMultiSet = false
      },
      async exportStation(){
        let res = await this.$commonFun.postProxy('admin/company/exportCompanyStation',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`${res.data.filename}.xlsx`)
        })
      },
      set_new_company_price(row,ttt){
        console.log('row0--0--',row)
        console.log('ttt---',ttt)
      },
          reloadPage(user_id){
        this.searchData.station_id = user_id
        this.getInfo()
      },
             refund(order_id){
        this.$Modal.confirm({
          title:'退款',
          render:(h)=>{
            return h( 'Input', {
              size: "large",
              modelValue: this.refundRemark,
              autofocus: true,
              placeholder: '请输入退款原因',
              on:{
                input:(val)=>{
                  this.refundRemark = val;
                }
              }
            })
          },
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/order/refund',{order_id,remark:this.refundRemark});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      cancelRefund(order_id){
        this.$Modal.confirm({
          title:'驳回退款',
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/order/cancelRefund',{order_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      showProof(info){
        let images = [];
        if (info.proof_car !== '') images.push(info.proof_car);
        if (info.proof_station !== '') images.push(info.proof_station);
        if (info.proof_mileage !== '') images.push(info.proof_mileage);
        this.$viewerApi({
          images: images,
          options: {
            initialViewIndex: 0,
          },
        })
      },

            timeChange(time) {
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchDatas.create_time = time
          this.searchData.create_time = time
          this.searchNew.create_time = time
        }
      },

    },
      watch:{
      user_id(new_user_id){
        this.reloadPage(new_user_id)
      }
   }
    
  }
</script>

<style scoped lang="less">
  .conItem{
    display: flex;
    border: 1px solid #e8eaec;
    padding: 5px;
    align-items: center;
    >p{
      margin-right: 10px;
      text-align: center;
    }

    .bianhao{
      width: 80px;
    }
    .id{
      width: 35px;
    }
    .station_id{
      text-align: center;
      width: 100px;
      >span{
        display: block;
      }
    }
    .money{
       width: 100px;
      >span{
        display: block;
      } 
    }
    .front_balance{
          width: 100px;
      >span{
        display: block;
      } 
    }
    .after_balance{
          width: 100px;
      >span{
        display: block;
      } 
    }
    .ip{
    width: 100px;
      >span{
        display: block;
      } 
    }
    .status{
      width: 100px;
      >span{
        display: block;
      } 
    }
    .gas_name{
      width: 120px;
      >span{
        display: block;
      }
    }
    .remarks{
       width: 300px;
      >span{
        display: block;
      }
    }
    .user_name{
        width: 100px;
      >span{
        display: block;
      }
    }
    .create_time{
         width: 100px;
      >span{
        display: block;
      }
    }
    .update_time{
      width: 140px;
    }
    .price{
       width: 140px;
       >span{
         display: block;
       }
     }
    .station_price{
      width: 140px;
      >span{
        display: block;
      }
    }
    .spread_price{
      width: 100px;
    }
    .editPrice{
      flex: 1;
      .editPriceInput{
        width:60px;
        margin-right: 5px;
      }
      >span{
        display: block;
      }
    }
  }
</style>